import { energyCardsSrcArray } from 'assets/img/cards/energyCards.js';
import React from 'react';
import styles from './prepaidCard.module.scss';

const CARD_WIDTH_PX = 140;
const CARD_GAP_PX = 10;

// One copy of the card set is ~1350px wide; the strip must cover the widest
// viewport plus one copy so the wrap-around never exposes a gap. Four copies
// cover viewports up to ~4000px.
const STRIP_COPIES = 4;

const generateKeyframe = (name, start, end) => {
  return `
    @keyframes ${name} {
        from {
            transform: translate(${start}px, 0);
          }

          to {
            transform: translate(${end}px, 0);
          }
    }
  `;
};

export const PrepaidLoadingAnimation = () => {
  const copyWidth = (CARD_WIDTH_PX + CARD_GAP_PX) * energyCardsSrcArray.length;

  return (
    <div>
      {/* Sliding right by exactly one copy-width per loop: after the wrap,
          each identical copy lands where its neighbour was, so the marquee
          is seamless at any viewport width the strip covers. */}
      <style>{generateKeyframe('slideCards', -copyWidth, 0)}</style>

      <div className={styles.loadingBanner}>
        <div
          style={{
            position: 'absolute',
            display: 'flex',
            gap: `${CARD_GAP_PX}px`,
            animation: 'slideCards 15s linear infinite',
          }}
        >
          {Array.from({ length: STRIP_COPIES }).map((_, copy) =>
            energyCardsSrcArray.map((img, i) => (
              <img
                alt=""
                key={`${copy}-${i}`}
                width={CARD_WIDTH_PX}
                src={img}
              />
            )),
          )}
        </div>
      </div>
    </div>
  );
};
